import React from 'react';
import { CardHeader } from '../../PanelComerciales.styles';

interface SectionHeaderProps {
    title: string;
    subtitle?: string;
    icon?: React.ReactNode;
    actions?: React.ReactNode;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, subtitle, icon, actions }) => (
    <CardHeader>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {icon ? <span style={{ display: 'inline-flex' }}>{icon}</span> : null}
            <div>
                <h3>{title}</h3>
                {subtitle ? <p>{subtitle}</p> : null}
            </div>
        </div>
        {actions ? <div>{actions}</div> : null}
    </CardHeader>
);

export default SectionHeader;
